import Block from 'block';

const $ = window.jQuery; 

// NOTE: 	block `.twig` requires `{{ js_attributes }}` on container (i.e. `{{
// classes }}`)  for below `init()` to correctly trigger

const block = new Block('sitequoteform'); // e.g. use `hero001` for
// `HERO/HER001`

block.init = function($el) {

    console.log('block init', block.id, $el);

    if( $('.quote-calculator').length) {

        let activeConversion = '';
        let query = '';
        hideConditionalFields();
        resetEstimate();
     
        //keep range and input in sync
        const rangeInputs = document.querySelectorAll('.quote-calculator .range-input');
        const numberInputs = document.querySelectorAll('.quote-calculator .number-input');
    
        rangeInputs.forEach((rangeInput, index) => {
            updateRangeProgress(rangeInput);
            rangeInput.addEventListener('input', () => {
                numberInputs[index].value = rangeInput.value;
                updateRangeProgress(rangeInput);
            });
        });
    
        numberInputs.forEach((numberInput, index) => {
            numberInput.addEventListener('input', () => {
                rangeInputs[index].value = numberInput.value;
                updateRangeProgress(rangeInputs[index]);
            });
        });
    
        $('.conversion-types input').change(function(event) {
            activeConversion = event.target.value;
            //depending on conversion slightly different choice of form fields
            updateForm(); 
        });
      
        $('.quote-calculator .tooltip').on( "mouseenter", function(event) { 
                                            $('#tooltip-content h3').html($(event.target).data('heading'));
                                            $('#tooltip-content p').html( $(event.target).data('tooltip'));
                                            $('#tooltip-content').css("visibility", "visible");
                                        })                                        
                                        .on( "mouseleave", function(event) { 
                                            $('#tooltip-content h3').html($(event.target).data(' '));
                                            $('#tooltip-content p').html( $(event.target).data(' '));
                                            $('#tooltip-content').css("visibility", "hidden");
                                        });
    
        $('.calculate-quote').click(function(event){
            event.preventDefault();
            $(this).blur();

            const minWidth = $('#property_width-0').data('min');
            const maxWidth = $('#property_width-0').data('max');
            const minDepth = $('#property_depth-0').data('min');
            const maxDepth = $('#property_depth-0').data('max');
            const minHeadroom = $('#head_room-0').data('min');
            const maxHeadroom = $('#head_room-0').data('max');
    
            const formData = new FormData(document.querySelector('.quote-calculator'));
            const conversion = formData.get('conversion');
            const propertyDepth = formData.get('property_depth') < minDepth ? minDepth : formData.get('property_depth') > maxDepth ? maxDepth : formData.get('property_depth');
            const propertyWidth = formData.get('property_width') < minWidth ? minWidth : formData.get('property_width') > maxWidth ? maxWidth : formData.get('property_width');
            const headRoom = formData.get('head_room') < minHeadroom ? minHeadroom : formData.get('head_room') >  maxHeadroom ? maxHeadroom : formData.get('head_room');

            // VELUX, DORMER, L-SHAPED DORMER
            // Question 5: Is the Roof Gable ended or Hipped?
            const gableEndedOrHipped = formData.get('gable_ended_or_hipped') == 'hipped' ? 'Hipped' : 'Gable Ended';
    
            // Multi Pitched Dormers
            // Question 2 = Quantity of Dormers: 2
            const quantityOfDormers = formData.get('quantity_of_dormers');
    
            // Example of form validation
            if(!conversion) { //conversion = null if not selected
                alert("please select a conversion type");
                return;
            }
    
            // Headroom
            // v1 - now may be specific
            // Please note where the answer to the question Head Room (m) = Below 2.1m 
            // please add £4000 to the total
            // const headRoomExtra = headRoom < 2.1 ? 4000 : 0;

            // v2 (Exclude mansard,double mansard)
            //Height: <2m add £2800 2m - 2.4m remains at price and >2.4m adds £1100
            let headRoomExtra = headRoom < 2 ? 2800 : 0;
            headRoomExtra = headRoom > 2.4 ? 1100 : 0;
            
            let unitCost, unitCostInitial, unitCostAbove35, size, addition, cost, costAbove, costMin, costMax, convLabel;
    
            switch(conversion) {
    
                // Velux Logic
                // Question 1 = Conversion Type:Velux
                // Question 2 = Property Depth (m): 7m
                // Question 3 = Property Width (m): 5m
                // Question 4: Head Room (m) - Top of Floor to Underside of Highest Point: 2.2m
                // Question 5: Is the Roof Gable ended or Hipped?

                // OLD
                // Cost Calculation: D x W x H - 7 x 5 x 2.2 = 77
                // Gable Ended or Hipped: Hipped = +£2000 Gable ended =+£0
                // Cost Applicable £610.38
                // Calculation: 77 x £610.38
                // Project Cost £47000
                // Cost Result = Minus £2500 - plus £2500 e.g. £44500 - £49500 Price as gable ended

                // NEW
                // Cost Calculation: D x - 7 x 5 = 35
                // Height: <2m add £2800 2m - 2.4m remains at price and >2.4m adds £1100
                // Gable Ended or Hipped: Hipped = +£2000 Gable ended =+£0
                // Cost Applicable £1342
                // Calculation: 35 x £1342 every 1 after is an extra £510 rather than £1342
                // Project Cost £47000
                // Cost Result = Minus £2500 - plus £2500 e.g. £44500 - £49500 Price as gable ended

                case 'velux': 
                    convLabel = 'Velux';
                    unitCostInitial = 1342;
                    unitCostAbove35 = 510;
                    size = propertyDepth * propertyWidth;
                    if (!validateSize(size)) { return; }
                    addition = gableEndedOrHipped == 'Hipped' ? 2000 : 0;

                    costAbove = 0;
                    cost = unitCostInitial * size;
                    if(size > 35) {
                        costAbove = (size - 35) * unitCostAbove35;
                        cost = costAbove + 35 * unitCostInitial
                    }

                    cost  = cost + addition + headRoomExtra;
                    costMin = Math.max(0, Math.round(cost - 2500));
                    costMax = Math.round(cost + 2500);
                    updateEstimate(convLabel, costMin, costMax, propertyDepth, propertyWidth, headRoom, gableEndedOrHipped);
                    break;
                // Dormer Logic
                // Question 1 = Conversion Type:Dormer
                // Question 2 = Property Depth (m): 7m
                // Question 3 = Property Width (m): 5m
                // Question 4: Head Room (m) - Top of Floor to Underside of Highest Point: 2.2m
                // Question 5: Is the Roof Gable ended or Hipped?

                // OLD
                // Cost Calculation: D x W x H - 7 x 5 x 2.2 = 77
                // Gable Ended or Hipped: Hipped = +£2000 Gable ended =+£0
                // Cost Applicable £701.30
                // Calculation: 77 x £701.30
                // Project Cost £54000
                // Cost Result = Minus £2500 - plus £2500 e.g. £51500 - £56500 Price as gable ended

                // NEW
                // Cost Calculation: D x W - 7 x 5 = 35
                // Height: <2m add £2800 2m - 2.4m remains at price and >2.4m adds £1100
                // Gable Ended or Hipped: Hipped = +£2000 Gable ended =+£0
                // Cost Applicable £1542
                // Calculation: First 35 x £1542 every 1 after is an extra £510 rather than £1542
                // Project Cost £54000
                // Cost Result = Minus £2500 - plus £2500 e.g. £51500 - £56500 Price as gable ended

                case 'dormer' :
                    convLabel = 'Dormer';
                    unitCostInitial = 1542;
                    unitCostAbove35 = 510;
                    size = propertyDepth * propertyWidth;
                    if (!validateSize(size)) { return; }
                    addition = gableEndedOrHipped == 'Hipped' ? 2000 : 0;

                    costAbove = 0;
                    cost = unitCostInitial * size;
                    if(size > 35) {
                        costAbove = (size - 35) * unitCostAbove35;
                        cost = costAbove + 35 * unitCostInitial
                    }

                    cost  = cost + addition + headRoomExtra;
                    costMin = Math.max(0, Math.round(cost - 2500));
                    costMax = Math.round(cost + 2500);
                    updateEstimate(convLabel, costMin, costMax, propertyDepth, propertyWidth, headRoom, gableEndedOrHipped);
                    break;
                // Multi Pitched Dormers Logic
                // Question 1 = Conversion Type:Multi Pitched Dormers
                // Question 2 = Quantity of Dormers: 2
                // Question 3 = Property Depth (m): 7m
                // Question 4 = Property Width (m): 5m
                // Question 5 = Head Room (m) - Top of Floor to Underside of Highest Point: 2.2m

                // OLD
                // Cost Calculation: D x W x H - 7 x 5 x 2.2 = 77
                // Cost Applicable £610.38
                // Calculation: 77 x £610.38
                // Project Cost £47000
                // Cost Per Dormer £6000 x 2
                // Total Project Cost: £59000
                // Cost Result = Minus £2500 - plus £2500 e.g. £56500 - £61500

                // NEW
                // Cost Calculation: D x W - 7 x 5 = 35
                // Height: <2m add £2800 2m - 2.4m remains at price and >2.4m adds £1100
                // Cost Applicable £1620
                // Calculation: 35 x £1342 every 1 after is an extra £510 rather than £1342
                // Project Cost £47000
                // Cost Per Dormer £6000 x 2
                // Total Project Cost: £59000
                // Cost Result = Minus £2500 - plus £2500 e.g. £56500 - £61500
                case 'multi_pitched_dormers' :
                    convLabel = 'Multi Pitched Dormers';
                    unitCostInitial = 1620;
                    unitCostAbove35 = 510;
                    size = propertyDepth * propertyWidth;
                    if (!validateSize(size)) { return; }

                    addition = gableEndedOrHipped == 'Hipped' ? 2000 : 0;
                    addition = addition + quantityOfDormers * 6000;

                    costAbove = 0;
                    cost = unitCostInitial * size;
                    if(size > 35) {
                        costAbove = (size - 35) * unitCostAbove35;
                        cost = costAbove + 35 * unitCostInitial
                    }
                    cost  = cost + addition + headRoomExtra;
                    costMin = Math.max(0, Math.round(cost - 2500));
                    costMax = Math.round(cost + 2500);
                    updateEstimate(convLabel, costMin, costMax, propertyDepth, propertyWidth, headRoom, '', quantityOfDormers);
                    break;
                // L Shape Dormer Logic
                // Question 1 = Conversion Type:L Shape Dormer
                // Question 2 = Property Depth (m): 7m
                // Question 3 = Property Width (m): 5m
                // Question 4: Head Room (m) - Top of Floor to Underside of Highest Point: 2.2m
                // Question 5: Is the Roof Gable ended or Hipped?

                // OLD
                // Cost Calculation: D x W x H - 7 x 5 x 2.2 = 77
                // Gable Ended or Hipped: Hipped = +£2000 Gable ended =+£0
                // Cost Applicable £766.24
                // Calculation: 77 x £766.24
                // Project Cost £59000
                // Cost Result = Minus £2500 - plus £2500 e.g. £56500 - £61500 Price as gable ended

                // NEW
                // Cost Calculation: D x W - 7 x 5 = 35
                // Height: <2m add £2800 2m - 2.4m remains at price and >2.4m adds £1100
                // Gable Ended or Hipped: Hipped = +£2000 Gable ended =+£0 
                // Cost Applicable £1800
                //  Calculation: 35 x £1800 every 1 after is an extra £510 rather than £1800
                // Project Cost £63000
                // Cost Result = Minus £2500 - plus £2500 e.g. £60500 - £65500 Price as gable ended
                case 'l_shaped_dormer' :
                    convLabel = 'L-Shaped Dormer';
                    unitCostInitial = 1800;
                    unitCostAbove35 = 510;
                    size = propertyDepth * propertyWidth;
                    if (!validateSize(size)) { return; }
                    addition = gableEndedOrHipped == 'Hipped' ? 2000 : 0;

                    costAbove = 0;
                    cost = unitCostInitial * size;
                    if(size > 35) {
                        costAbove = (size - 35) * unitCostAbove35;
                        cost = costAbove + 35 * unitCostInitial
                    }

                    cost  = cost + addition + headRoomExtra;
                    costMin = Math.max(0, Math.round(cost - 2500));
                    costMax = Math.round(cost + 2500);
                    updateEstimate(convLabel, costMin, costMax, propertyDepth, propertyWidth, headRoom, gableEndedOrHipped);
                    break;
                // Mansard Logic
                // Question 1 = Conversion Type:Mansard
                // Question 2 = Property Depth (m): 7m
                // Question 3 = Property Width (m): 5m

                // OLD
                // Cost Calculation: D x W x H - 7 x 5 = 35
                // Cost Applicable £2057.14
                // Calculation: 35 x £2057.14
                // Project Cost £72000
                // Cost Result = Minus £2500 - plus £2500 e.g. £69500 - £74500

                // Cost Calculation: D x W - 7 x 5 = 35
                // Cost Applicable £2057.14
                // Calculation: 35 x £2057.14 every 1 after is an extra £510 rather than £2057
                // Project Cost £72000 
                // Cost Result = Minus £2500 - plus £2500 e.g. £69500 - £74500
                case 'mansard' :
                    convLabel = 'Mansard';
                    unitCostInitial = 2057.14;
                    unitCostAbove35 = 510;
                    size = propertyDepth * propertyWidth;
                    if (!validateSize(size)) { return; }
                    costAbove = 0;
                    cost = unitCostInitial * size;
                    if(size > 35) {
                        costAbove = (size - 35) * unitCostAbove35;
                        cost = costAbove + 35 * unitCostInitial
                    }
                    costMin = Math.max(0, Math.round(cost - 2500));
                    costMax = Math.round(cost + 2500);
                    updateEstimate(convLabel, costMin, costMax, propertyDepth, propertyWidth, headRoom);
                    break;
                // Double Pitched Mansard Logic
                // Question 1 = Conversion Type:Double Pitched Mansard
                // Question 2 = Property Depth (m): 7m
                // Question 3 = Property Width (m): 5m

                // OLD
                // Cost Calculation: D x W x H - 7 x 5 = 35
                // Cost Applicable £2200
                // Calculation: 35 x £2200
                // Project Cost £77000
                // Cost Result = Minus £2500 - plus £2500 e.g. £74500 - £79500

                // NEW
                // Cost Calculation: D x W - 7 x 5 = 35
                // Cost Applicable £2200
                // Calculation: 35 x £2200 every 1 after is an extra £510 rather than £2057
                // Project Cost £77000
                // Cost Result = Minus £2500 - plus £2500 e.g. £74500 - £79500
                case 'double_pitched_mansard' :
                    convLabel = 'Double Pitched Mansard';
                    unitCostInitial = 2200;
                    unitCostAbove35 = 510;
                    size = propertyDepth * propertyWidth;
                    if (!validateSize(size)) { return; }
                    costAbove = 0;
                    cost = unitCostInitial * size;
                    if(size > 35) {
                        costAbove = (size - 35) * unitCostAbove35;
                        cost = costAbove + 35 * unitCostInitial
                    }
                    costMin = Math.max(0, Math.round(cost - 2500));
                    costMax = Math.round(cost + 2500);
                    updateEstimate(convLabel, costMin, costMax, propertyDepth, propertyWidth, headRoom);
                    break;
                default: 
                    reset();
                    break;
            }

            updateQueryString(convLabel, propertyWidth, propertyDepth, 
                            headRoom, gableEndedOrHipped, quantityOfDormers,
                            costMin, costMax);
    
        });
    
        $('.quote-calculator .reset').on('click', function(event) {
            reset();
            $(this).blur();
        });

        $('.quote-calculator #quote-link').on('click', function(event) {
            if(!query) {
                return;
            }
            event.preventDefault();
            const $url = $(this).attr("href") + '?' + query;
            window.location = $url;
        });

        function updateQueryString(conversion, propertyWidth, propertyDepth, 
                                    headRoom, gableEndedOrHipped, quantityOfDormers,
                                costMin, costMax) {
            const params = {
                c: conversion,
                wi: propertyWidth,
                d: propertyDepth,
                h: headRoom,
                gh: gableEndedOrHipped,
                dq: quantityOfDormers,
                min: costMin,
                max: costMax
            };
            query = $.param(params);           
        }
    
        function validateSize(size, msg = false) {
            if(!size) {
                msg ? alert(msg) : alert('Please enter all required details');
                return false
            }
            return true;
        }
    
        function reset() {
            resetEstimate();
            hideConditionalFields();
            activeConversion = null;
            query = '';
            rangeInputs.forEach((rangeInput, index) => {
                // give 10ms for the input to reset first
                setTimeout(function(){updateRangeProgress(rangeInput);}, 10);
            });
        }
    
        function toggleField(field, show) {
            show ? $(field).show() : $(field).hide();
        }
        
        function hideConditionalFields() {
            toggleField('.form-field-head_room', false);
            toggleField('.form-field-gable_ended_or_hipped', false);
            toggleField('.form-field-quantity_of_dormers', false);
        }
    
        function updateForm() {
            hideConditionalFields();
            switch(activeConversion) {
                case 'velux': // 1 dormer, no QofD
                case 'l_shaped_dormer' : // no QofD
                case 'dormer' : // 1 dormer, no QofD
                    toggleField('.form-field-gable_ended_or_hipped', true);
                    toggleField('.form-field-head_room', true);
                    break;
                case 'multi_pitched_dormers' : // no gabled/hipped
                    toggleField('.form-field-quantity_of_dormers', true);
                    toggleField('.form-field-head_room', true);
                    break;
                // case 'mansard' : // no QofD, no headroom, no gabled/hipped
                // case 'double_pitched_mansard' :
                //     break;
                default: 
                    break;
            }
        }
    
        function updateEstimate(label, min, max, d, w, h = 0, gh = '', q = '' ) {
            $('.estimate-range').html(`£<span class="cost-min text-5xl">${min}</span> - £<span class="cost-max text-5xl">${max}</span>`);
            $('.estimate-type').text(label);
            $('.estimate-width').text(w);
            $('.estimate-depth').text(d);
            $('.estimate-headroom').text(h);
            $('.estimate-gable_ended_or_hipped').text(gh);
            $('.estimate-quantity_of_dormers').text(q);
            $('.estimate table').css('visibility', 'visible');
        }
    
        function resetEstimate() {
            $('.estimate-range').html('£<span class="text-5xl">0</span>');
            $('.estimate table').css('visibility', 'hidden');
        }
  
        function updateRangeProgress(el) {
            if(!el) {
                return;
            }
            const min = $(el).attr("min");
            const max = $(el).attr("max");
            const value = el.value;
            const ratio = ( value - min ) / ( max - min );
            const progress = ratio * 100;
            el.style.background = `linear-gradient(to right, #F8F77F ${progress}%, #CDD8DE ${progress}%)`;
        }
    
    }


};

